import React, { FC } from 'react'
import { AiOutlineLoading } from 'react-icons/ai'

interface Props {
  className?: string
  color?: string
  size?: number
}

const Loading: FC<Props> = (props) => {
  const { className = '', size = 40, color = '#999999' } = props
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div className="animate-spin inline-block m-auto">
        <AiOutlineLoading size={size} color={color} />
      </div>
    </div>
  )
}

export default Loading
